export default __webpack_public_path__ + "static/media/laura.6d68b619.png";